var render = function render(){var _vm=this,_c=_vm._self._c;return _c('attendEmployee',{attrs:{"isLoad":_vm.isLoad,"messageApi":_vm.messageApi,"name":"حضور الموظفين"},on:{"downLoadExcel":_vm.fetchData}})
}
var staticRenderFns = []

export { render, staticRenderFns }